<script setup lang="ts">
import { Promotion, PromotionType } from '@rediredi/types'

const props = defineProps<{
  context: 'grid' | 'list' | 'details'
  promotion?: Promotion
  type: 'outOfStock' | 'promotion'
}>()

const isDiscountsEnabled = true

const promotionType = computed(() => {
  if (props.promotion?.type === PromotionType.Label) return props.promotion?.promotionLabel
  if (props.promotion?.type === PromotionType.Discount)
    return `${props.promotion?.promotionPercent || 0}% OFF`
  if (props.promotion?.type === PromotionType.SellingPrice)
    return `${formatPrice(props.promotion?.promotionPrice?.amount || 0, {
      currency: props.promotion.promotionPrice?.currency,
    })} OFF`

  return ''
})

const typeClasses = computed(() => {
  if (props.type === 'promotion' && isDiscountsEnabled) return 'bg-red-300'
  return 'bg-carrot-orange'
})
</script>

<template>
  <div
    class="out-of-stock absolute right-1 top-1 z-10 flex items-center justify-center overflow-hidden rounded-sm px-1 py-0.5 text-xs font-extrabold uppercase text-white"
    :class="[typeClasses]"
  >
    <template v-if="props.type === 'outOfStock' || !isDiscountsEnabled">
      {{ $t('globals.products.outOfStock') }}
    </template>
    <template v-else-if="props.type === 'promotion'">
      {{ promotionType }}
    </template>
  </div>
</template>
